// extracted by mini-css-extract-plugin
export default {"edit_mainCont":"ChangePassword_edit_mainCont__8G2U8","edit_heading":"ChangePassword_edit_heading__jao+B","logoutCheck":"ChangePassword_logoutCheck__H0xYP"};